export default class {
    constructor (template, component, cacheDomArray = []) {
        this.#template = template;
        this.#component = component;

        if (!Array.isArray(cacheDomArray)) {
            wealthify.error.throwError('DomCache class', `The cacheDom constructor property on ${this.#component.tagName} must be an array.`);
        }

        [...this.#defaultCacheDomArray, ...cacheDomArray].forEach((item) => this.#queryAndPreCatchItemsByAttribute(item));

        // Create a proxy to self which creates general getter trap
        return new Proxy(this, this);
    }


    // Private properties

    #defaultCacheDomArray = [
        'data-root',
        'data-child-root'
    ];
    #template = null;
    #component = null;
    #store = {};


    // Public methods

    get (domCacheClass, cacheName) {
        if (!this.#store[cacheName]) {
            this.#queryAndCacheItemByName(cacheName);
        }

        return Object.prototype.hasOwnProperty.call(this.#store, cacheName)
            ? this.#store[cacheName]
            : undefined;
    }

    set (domCacheClass, cacheName, value) {
        const isNodeList = wealthify.dom.isNodeList(value);
        const isNode = wealthify.dom.isNode(value);
        const isEmptyArray = Array.isArray(value) && value.length === 0;

        if (isNodeList) {
            this.#storeCacheItems(cacheName, value);
        } else if (isNode || isEmptyArray) {
            this.#store[cacheName] = value;
        }

        return true;
    }


    // Private methods

    get #domSource () {
        return this.#isTemplateUsed ? this.#template : this.#component;
    }

    get #isTemplateUsed () {
        return this.#template.children.length;
    }

    #queryAndPreCatchItemsByAttribute (selector) {
        // Route used by WebComponent base for pre-cache query
        // Comes through as selector - data-xx-yy-zz
        const name = selector.split('data-')[1];

        if (!name) {
            wealthify.error.throwError('DomCache class', `Selector ${selector} on component ${this.#component.tagName} must use a data attribute.`);
        }

        const elements = this.#queryItems(name);

        if (!elements.length && !this.#defaultCacheDomArray.includes(selector)) {
            wealthify.error.throwError('DomCache class', `No element found in ${this.#component.tagName} template with selector [${selector}].`);
        }

        return this.#storeCacheItems(name, elements);
    }

    #queryAndCacheItemByName (name) {
        // Route used by getter for post-construction query
        // Comes through as cacheName - xxYyZz
        const elements = this.#queryItems(name);
        // Ensure that elements are direct descendants of component
        // Since this route is post-construction, the component can contain
        // other components with their own children (which can be wrongly selected here)
        const directChildrenOfComponent = wealthify.dom.filterByComponentDirectDescendants(this.#domSource, elements);

        return this.#storeCacheItems(name, directChildrenOfComponent);
    }

    #queryItems (name) {
        const kebabCaseName = wealthify.convert.toKebabCase(name);
        const dataAttributeSelector = `[data-${kebabCaseName}]`;

        return this.#domSource.querySelectorAll(dataAttributeSelector);
    }

    #storeCacheItems (name, elements) {
        const cacheName = wealthify.convert.toCamelCase(name);

        // TODO: Store single items as single item in array, not bare single item
        // All components currently rely on single items being stored this way
        if (!elements.length) {
            // If default item not found, store as undefined
            this.#store[cacheName] = undefined;
        } else {
            // If > 1, store as an array, otherwise store as single element
            this.#store[cacheName] = elements.length === 1
                ? elements[0]
                : [...elements];
        }
    }
}